import { request } from "@/request/index";

// 获取订单链接
export function myCardOrder(itemSku, userId, goodsPackDetail, sandbox, appid, country) {
    return request({
        // baseURL: "http://10.80.1.176:8888",     // 测试用
        // url: "/paypal_order",                   // 测试用

        method: "POST",
        data: {
            action: "mycard_order",
            appid,
            sandbox,
            itemSku,
            userId,
            goodsPackDetail,
            country
        }
    })
}

// 查看订单的状态
export function checkMyCardOrderStatus(appid, orderId, sandbox) {
    return request({
        // baseURL: "http://10.80.1.176:8888",     // 测试用
        // url: "/check_paypal_order",             // 测试用

        method: "POST",
        data: {
            action: "check_mycard_order",
            appid,
            orderId,
            sandbox
        }
    })
}